import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import Home from './views/Home';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import FailuresTracker from './views/FailuresTracker/components/FailuresTracker';
import DualMap from './views/DualMap/components/DualMap';
import SiteOptTracker from './views/SiteOptimizationsTracker/components/SiteOptTracker';
import RepositoryExcel from './views/RepositoryExcel/components/RepositoryExcel';
import RepositoryPdf from './views/RepositoryPdf/components/RepositoryPdf';
import DriveTestUpload from './views/DriveTestUpload/components/DriveTestUpload';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								// component: (props) => AuthGuard({
								// 	// : ['Administrator', 'Manager'],
								// 	children: Home(props)
								// }),
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 1 } }, pageTitle: 'Home', module: 'Home' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/modules',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/modules/failuresTracker/:id',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: FailuresTracker()
								}),
							},
							{
								path: '/modules/dualMap',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DualMap()
								}),
							},
							{
								path: '/modules/repositoryPdf',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: RepositoryPdf()
								}),
							},
							{
								path: '/modules/repositoryExcel',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: RepositoryExcel()
								}),
							},
							{
								path: '/modules/driveTestUpload',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: DriveTestUpload()
								}),
							},
							{
								path: '/modules/siteOptTracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: SiteOptTracker()
								}),
							},
							{
								path: '/modules/dashboard1',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 1 } }, pageTitle: 'Dashboard1', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard2',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard3',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 3 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard4',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 4 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard5',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 5 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard6',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 6 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								path: '/modules/dashboard7',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'Dashboard2', module: 'Modules' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/dashboardOne',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Page Title', module: 'Module' })
								}),
							},
							{
								path: '/dashboards/dashboardTwo',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Page Title', module: 'Module' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/requestAccess',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccess')),
			},
			{
				path: '/auth/requestAccessConfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccessConfirmation')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	}
];

export default routes;
